// extracted by mini-css-extract-plugin
module.exports = {"aditionalDescription":"AditionalForm_aditionalDescription__Rf5zn","personalizedProgramButtons":"AditionalForm_personalizedProgramButtons__VK3Dy"};